var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1221 44.9769L13.9127 45C9.02546 45 5.02892 41.0093 5.02314 36.1221L5.00001 13.9127C4.99422 9.02546 8.99075 5.02892 13.878 5.02314L36.0874 5.00001C40.9688 4.99422 44.9711 8.99075 44.9769 13.878L45 36.0874C45.0058 40.9746 41.0093 44.9711 36.1221 44.9769Z",
    fill: "url(#paint0_radial_1020_12898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1221 44.9769L13.9127 45C9.02546 45 5.02892 41.0093 5.02314 36.1221L5.00001 13.9127C4.99422 9.02546 8.99075 5.02892 13.878 5.02314L36.0874 5.00001C40.9688 4.99422 44.9711 8.99075 44.9769 13.878L45 36.0874C45.0058 40.9746 41.0093 44.9711 36.1221 44.9769Z",
    fill: "url(#paint1_radial_1020_12898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 32.7732C20.7145 32.7732 17.2269 29.2857 17.2269 25C17.2269 20.7143 20.7145 17.2267 25.0002 17.2267C29.2859 17.2267 32.7735 20.7143 32.7735 25C32.7735 29.2857 29.2859 32.7732 25.0002 32.7732ZM25.0002 19.4476C21.9406 19.4476 19.4479 21.9404 19.4479 25C19.4479 28.0595 21.9406 30.5523 25.0002 30.5523C28.0598 30.5523 30.5526 28.0595 30.5526 25C30.5526 21.9404 28.0598 19.4476 25.0002 19.4476Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9942 16.6714C34.9942 17.591 34.2482 18.3371 33.3285 18.3371C32.4089 18.3371 31.6628 17.591 31.6628 16.6714C31.6628 15.7518 32.4089 15.0057 33.3285 15.0057C34.2482 15.0057 34.9942 15.7518 34.9942 16.6714Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.663 39.436H18.3374C14.0517 39.436 10.5641 35.9485 10.5641 31.6628V18.3371C10.5641 14.0514 14.0517 10.5638 18.3374 10.5638H31.663C35.9487 10.5638 39.4363 14.0514 39.4363 18.3371V31.6628C39.4363 35.9485 35.9487 39.436 31.663 39.436ZM18.3374 12.7848C15.2778 12.7848 12.785 15.2776 12.785 18.3371V31.6628C12.785 34.7223 15.2778 37.2151 18.3374 37.2151H31.663C34.7226 37.2151 37.2153 34.7223 37.2153 31.6628V18.3371C37.2153 15.2776 34.7226 12.7848 31.663 12.7848H18.3374Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1020_12898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8699 45.0274) scale(49.8588 49.8588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3484,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5039,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6433,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8414,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1020_12898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4366 4.50117) scale(33.1069 22.0591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.bf2ca5586137b6eefa02fb12922e6499.svg";
export { ForwardRef as ReactComponent };